<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>

import BottomSheet from '../BottomSheet';
import DeviceList from './List';
import DeviceEditor from './Editor';
import DeviceRead from './Read';
import ListDataEditor from '../content/ListDataEditor';

export default {
  name: "DevicesPage",
  components: {
    BottomSheet
  },
  routes: [
    {
      path: '',
      redirect: '/devices/devices/list'
    },
    {
      path: "list",
      component: DeviceList,
      name: "Devices list"
    },
    {
      path: "new",
      name: "Devices new",
      components: {
        default: DeviceList,
        bottomEditor: DeviceEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        edit: "Devices edit"
      }     
    },
    {
      path: "edit/:id",
      name: "Devices edit",
      components: {
        default: DeviceList,
        bottomEditor: DeviceEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
    },
    {
      path: "read",
      name: "Devices read",
      components: {
        default: DeviceList,
        bottomEditor: DeviceRead
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        edit: "Device read"
      }
    },
    {
      path: "content_edit/:id/:data_id",
      name: "Content edit",
      components: {
        default: DeviceList,
        bottomEditor: ListDataEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
    }
  ]
}
</script>